/* eslint-disable import/prefer-default-export */

export const destinationTypes = {
  EMAIL: 'email',
  USERID: 'userId',
  SPACEID: 'spaceId',
  SIP: 'sip',
  PSTN: 'pstn'
};
